import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Ranking',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "9", y1: "31", x2: "23", y2: "31" }
      }), h("path", {
        attrs: { d: "M24 9.47V0H8v9.47c0 6.39 3.63 8.94 6 9.93V23h-4v8h12v-8h-4v-3.6c2.37-.99 6-3.54 6-9.93zM19 26v2h-6v-2h6z" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M23.5 3H30v2c0 4.97-3.03 9-8 9M8.5 3H2v2c0 4.97 3.03 9 8 9" }
      })]
    );
  }
};